import { createFileRoute } from '@tanstack/react-router'
import { TicketDetailPage } from '@/features/tickets/components/ticket-detail'

export const Route = createFileRoute('/_authenticated/tickets/$ticketId')({
  component: TicketDetailRoute,
})

function TicketDetailRoute() {
  const { ticketId } = Route.useParams()
  return <TicketDetailPage ticketId={Number(ticketId)} />
}
